import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useCallback } from 'react'
import { useParams } from 'react-router'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export function useCurrentApplication() {
  const params = useParams()
  const appKey = params.appKey
  const { getApplicationsApiGetApplications } = useRestClient()

  const select = useCallback(
    (data: MessagesApplicationsApplication[]) => data.find((x) => x.appKey === appKey),
    [appKey]
  )

  const { data: application } = getApplicationsApiGetApplications.useSuspenseQuery(undefined, {
    select,
  })

  if (!application) {
    throw new Error('Application not found')
  }

  return application
}
